import React from 'react';

import NewUpdateRole from 'components/Tvendo/Setting/Role/Maintenance/NewUpdateRole';

export default function () {
  return <NewUpdateRole />;
}
